import React from 'react';
import PropTypes from 'prop-types';
import { SvgX, SvgWrapper } from '../../svg';
import { PillWrapper } from './styles';
import { useTheme } from '../../theme';

function Pill(props) {
  const { children, type, onRemove, noMargin, style, size = 'default' } = props;
  const theme = useTheme();

  return (
    <PillWrapper noMargin={noMargin} size={size} type={type} style={style}>
      {children}
      {onRemove && (
        <SvgWrapper style={{ cursor: 'pointer', marginLeft: 10 }} onClick={onRemove}>
          <SvgX stroke={type === 'dark' ? theme.colors.secondary95w : theme.colors.secondary40w} />
        </SvgWrapper>
      )}
    </PillWrapper>
  );
}

Pill.propTypes = {
  children: PropTypes.node,
  noMargin: PropTypes.bool,
  style: PropTypes.object,
  type: PropTypes.oneOf(['light', 'dark']),
  size: PropTypes.oneOf(['default', 'small']),
  onRemove: PropTypes.func,
};

export default Pill;
